export interface ClientDto {
  clientId: string;
  grantTypes: string[];
  public: boolean;
  thirdParty: boolean;
  expirationDate: string;
  owner: string;
  scopes: string[];
}

export interface ScopeDto {
  name: string;
  description: string;
  service: string;
  piiAccess: boolean;
  expirationDate: string;
}

export enum Tenant {
  DE = 'DE',
  AT = 'AT',
}

export interface ClientCreationResponseDto {
  clientId: string;
  clientSecret: string;
}

export interface ClientCreationDto {
  clientId: string;
  description: string;
  owner: string;
  publicClient: boolean;
  thirdPartyClient: boolean;
  scopes: string;
  tokenTTL: string;
  grantTypes: GrantTypes;
  redirectUris: string;
  tenant: Tenant;
}

export enum GrantTypes {
  AUTHORIZATION_CODE = 'AUTHORIZATION_CODE',
  CLIENT_CREDENTIALS = 'CLIENT_CREDENTIALS'
}
